import React from "react";
import { Outlet } from "react-router-dom";

function Appraisal() {
  return (
    <>
      <Outlet></Outlet>
    </>
  );
}

export default Appraisal;
